export default [{
  id: '12554705-e965-df71-f2d0-acd8fb818cda', // id 全局唯一，终身制
  name: 'cableTrayManagement',
  path: '/cable-tray',
  meta: {
    title: '电缆桥架管理'
  },
  // layout: 'default',
  // 根菜单不需要定义 component，由主框架定义
  children: [{
    id: '4dcacaa1-6dd4-23b0-4e0d-576cdccf9c2d',
    path: 'index',
    name: 'cableist',
    component(resolve) {
      require(['./views/index'], resolve)
    },
    meta: {
      title: '电缆桥架',
      operations: {
        create: {
          id: 0,
          name: 'create',
          desc: '新增',
          access: true,
        },
        read: {
          id: 1,
          name: 'read',
          desc: '详情',
          access: true,
          group: 'read',
        },
        update: {
          id: 2,
          name: 'update',
          desc: '修改',
          access: true,
        },
        delete: {
          id: 3,
          name: 'delete',
          desc: '删除',
          access: true,
        }
      },
    },
  },
  {
    id: 'c0126a98-14d7-ffd8-4fb4-e4cc909ec90f',
    path: 'create-cable',
    name: 'create-cable',
    component(resolve) {
      require(['./views/create'], resolve)
    },
    meta: {
      title: '新增电缆桥架',
      hidden: true,
      operations: {
        create: {
          id: 0,
          name: 'create',
          desc: '新增',
          access: true,
        },
        read: {
          id: 1,
          name: 'read',
          desc: '详情',
          access: true,
          group: 'read',
        },
        update: {
          id: 2,
          name: 'update',
          desc: '修改',
          access: true,
        },
        delete: {
          id: 3,
          name: 'delete',
          desc: '删除',
          access: true,
        },
      },
    },
  },


  ],
},


]
